(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.componentCyoa = {
    animationSequencePrimary: $primaryItem => {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {clickGuard, animPrimaryPhaseTwo, getParentNav, isMobileCheck, subsitePageCheck, toggleScrolling, toggleCloseButton} = componentContext;

      const $parentNav = getParentNav($primaryItem);

      clickGuard($primaryItem);
      if (isMobileCheck()) {
        toggleScrolling();
        toggleCloseButton($parentNav);
        if (subsitePageCheck()) {
          $parentNav.classList.add('transition-start-subsite-page');
        }
      }

      $parentNav.classList.add('transition-start');

      const $primaryChildren = $parentNav.querySelectorAll(':scope > .cyoa-nav-item');
      $primaryChildren.forEach(item => item.classList.remove('active'));
      $primaryItem.classList.add('active');
      setTimeout(animPrimaryPhaseTwo.bind($primaryItem), 310);
    },
    animPrimaryPhaseTwo: function () {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {animPrimaryPhaseThree, getParentNav} = componentContext;
      const $parentNav = getParentNav(this);
      $parentNav.classList.add('transition-two');
      this.style.maxHeight = this.dataset.height;
      setTimeout(animPrimaryPhaseThree.bind(this), 510);
    },
    animPrimaryPhaseThree: function () {
      this.classList.add('complete');
      const $childNav = this.querySelector(':scope > ul');
      Drupal.behaviors.componentCyoa.animSecondaryPhase.apply($childNav);
    },
    animSecondaryPhase: function () {
      const componentContext = Drupal.behaviors.componentCyoa;

      setTimeout(()=> {
        this.classList.add('active');
      }, 100);
      setTimeout(()=> {
        this.closest('li').classList.add('show-children');
      }, 150);
      setTimeout(()=> {
        componentContext.clickGuard(this, true);
      }, 700);
    },
    toggleScrolling: (enable = false) => {
      const $root = document.querySelector('html');
      const $body = document.querySelector('body');
      if (enable) {
        $body.classList.remove('overflow-hidden');
        $root.classList.remove('overflow-hidden');
      }
      else {
        $body.classList.add('overflow-hidden');
        $root.classList.add('overflow-hidden');
      }
    },
    animTertiary: ($targetEl) => {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {clickGuard, getParentNav, isMobileCheck} = componentContext;
      clickGuard($targetEl);
      const $parentNav = getParentNav($targetEl);
      const $previousBackBtn = $targetEl.closest('ul').closest('.complete');
      $previousBackBtn.classList.add('disabled');
      $targetEl.classList.add('active');
      $parentNav.classList.add('transition-start');

      const transitionTwoTiming = isMobileCheck() ? 850 : 350;
      setTimeout(()=> {
        $parentNav.classList.add('transition-two');
      }, transitionTwoTiming);
      setTimeout(()=> {
        $targetEl.querySelector('ul').classList.add('active');
      }, 700);
      setTimeout(() => {
        $targetEl.classList.add('complete');
        $targetEl.querySelector('ul').classList.add('transition-start');
        $previousBackBtn.classList.add('see-through');
      }, 800);
      setTimeout(()=> {
        clickGuard($targetEl, true);
      }, 1300);
    },
    backBtnTransition: $targetEl => {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {clickGuard, toggleScrolling, toggleCloseButton, isMobileCheck} = componentContext;
      const $parentNav = $targetEl.parentElement;
      const $root = $targetEl.closest('.cyoa');

      if (isMobileCheck()) {
        toggleScrolling(true);
      }

      toggleCloseButton($parentNav, true);
      clickGuard($targetEl);
      $root.classList.add('transition-close');

      $targetEl.classList.remove('show-children');
      setTimeout(()=> {
        $targetEl.classList.remove('complete');
      }, 610);
      setTimeout(()=> {
        $parentNav.classList.remove('transition-two');
      }, 1000);
      setTimeout(()=> {
        $parentNav.classList.remove('transition-start-subsite-page');
        $parentNav.classList.remove('transition-start');
        $targetEl.classList.remove('active');
      }, 1100);
      setTimeout(()=> {
        $parentNav.querySelectorAll('.active').forEach($activeItem => $activeItem.classList.remove('active'));
        $root.classList.remove('transition-start-subsite-page');
        $root.classList.remove('transition-start');
      }, 1200);
      setTimeout(()=> {
        $root.classList.remove('transition-close');
        clickGuard($targetEl, true);
      }, 1700);
    },
    nestedBackBtnTransition: $targetEl => {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {clickGuard} = componentContext;
      clickGuard($targetEl);
      const $parentBackBtn = $targetEl.parentElement.closest('li');
      const $childNav = $targetEl.querySelector('ul');
      const $parentNav = $targetEl.closest('ul');

      $childNav.classList.remove('transition-start-subsite-page');
      $childNav.classList.remove('transition-start');

      setTimeout(() => {
        $childNav.classList.remove('active');
      }, 510);
      setTimeout(() => {
        $targetEl.classList.remove('complete');
      }, 800);
      setTimeout(() => {
        $parentBackBtn.classList.remove('see-through');
        $parentBackBtn.classList.remove('disabled');
      }, 1300);
      setTimeout(() => {
        $targetEl.classList.remove('active');
        $targetEl.classList.add('hidden');
        $parentNav.classList.remove('transition-two');
      }, 1400);
      setTimeout(() => {
        $targetEl.classList.remove('hidden');
      }, 1500);
      setTimeout(() => {
        $targetEl.classList.remove('hidden');
        $parentNav.classList.remove('transition-start-subsite-page');
        $parentNav.classList.remove('transition-start');
      }, 1550);
      setTimeout(()=> {
        clickGuard($targetEl, true);
      }, 1750);
    },
    clickGuard: ($targetEl, enable = false) => {
      const $root = $targetEl.closest('.cyoa');
      if (enable) {
        $root.classList.remove('click-guard');
      }
      else {
        $root.classList.add('click-guard');
      }
    },
    getParentNav: $targetItem => {
      return $targetItem.closest('ul');
    },
    toggleCloseButton: ($targetEl, hideClose = false) => {
      const $root = $targetEl.closest('.cyoa');
      const $closeButton = $root.querySelector('.cyoa-close-btn');
      if (hideClose) {
        $closeButton.classList.remove('opacity-100');
      }
      else {
        setTimeout(()=>{
          $closeButton.classList.add('opacity-100');
        }, 1000);
      }
    },
    resetCyoa: (event) => {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {backBtnTransition, nestedBackBtnTransition, resetSubnavPanels} = componentContext;
      const $targetEl = event.currentTarget;
      const $root = $targetEl.closest('.cyoa');
      const $topLevelBackButton = $root.querySelector('.complete');
      const $hiddenBackButton = $root.querySelector('.see-through');
      const $nestedBackButton = $root.querySelector('.see-through .complete');
      if ($nestedBackButton) {
        nestedBackBtnTransition($nestedBackButton);
        setTimeout(backBtnTransition($hiddenBackButton), 1700);
      }
      else {
        backBtnTransition($topLevelBackButton);
      }
      resetSubnavPanels($targetEl);
    },
    resetSubnavPanels: $targetEl => {
      const $root = $targetEl.closest('.cyoa');
      const $activePanels = $root.querySelectorAll('[data-subnavpanel="true"].active');
      $activePanels.forEach(item => item.classList.remove('active'));
    },
    navClickHandler: event => {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {animationSequencePrimary, animTertiary, backBtnTransition, isMobileCheck, nestedBackBtnTransition, resetSubnavPanels, subsitePageCheck} = componentContext;
      event.preventDefault();
      const $targetEl = event.currentTarget.closest('li');
      const $root = $targetEl.closest('.cyoa');
      const isBackButton = $targetEl.closest('li').classList.contains('complete');
      const isNestedBackButton = $targetEl.parentElement.closest('li') && $targetEl.parentElement.closest('li').classList.contains('see-through');
      const isSecondaryParent = $targetEl.parentElement.classList.contains('cyoa-nav-child');
      resetSubnavPanels($targetEl);

      if (isSecondaryParent && !isBackButton) {
        animTertiary($targetEl);
        return;
      }
      if (isNestedBackButton) {
        nestedBackBtnTransition($targetEl);
        return;
      }
      else if (isBackButton) {
        backBtnTransition($targetEl);
        return;
      }
      animationSequencePrimary($targetEl);
      if (isMobileCheck && subsitePageCheck()) {
        $root.classList.add('transition-start-subsite-page');
      }
      else {
        $root.classList.add('transition-start');
      }
    },
    getElementHeight: $el => {
      return $el ? $el.clientHeight : 0;
    },
    setSubnavPanelHeight: ($targetEl) => {
      const {getElementHeight} = Drupal.behaviors.componentCyoa;
      const $subnavPanel = $targetEl.querySelector('.cyoa-subnav-panel');

      if ($subnavPanel.dataset.height) {
        return;
      }

      const $drupalNav = document.getElementById('toolbar-bar');
      const $alert = document.querySelector('.sitewide-alert');
      const $backButton = document.querySelector('.cyoa-nav-item.complete.active > .cyoa-nav-item--trigger');
      const $mainNav = document.querySelector('.cyoa-nav-primary');
      const clientHeight = document.documentElement.clientHeight;
      const drupalNavHeight = getElementHeight($drupalNav);
      const alertHeight = getElementHeight($alert);
      const backbuttonHeight = getElementHeight($backButton);
      const mainNavHeight = getElementHeight($mainNav);
      const contentHeight = clientHeight - drupalNavHeight - alertHeight - backbuttonHeight - mainNavHeight;
      $subnavPanel.style.height = `${contentHeight}px`;
      $subnavPanel.dataset.height = `${contentHeight}px`;
    },
    subNavPanelClickHandler: ($subnavPanelLinks, event) => {
      // If the clicked element is within a flyout panel, don't handle the click event.
      if (event.target.closest('.cyoa-subnav-panel')) {
        return;
      }
      const {isMobileCheck, toggleScrolling, backBtnTransition, setSubnavPanelHeight} = Drupal.behaviors.componentCyoa;
      const $targetEl = event.currentTarget;
      const $root = $targetEl.closest('.cyoa');
      const contentWrapper = event.target.closest('.cyoa-subnav-panel-content');
      const $targetPanel = $targetEl.querySelector('.cyoa-subnav-panel-content');
      const $allPanels = $targetEl.parentElement.querySelectorAll('.cyoa-subnav-panel-content');

      if (isMobileCheck()) {
        setSubnavPanelHeight($targetEl);
      }

      if ($targetEl.classList.contains('active') && contentWrapper === null) {
        $targetEl.classList.remove('active');

        if (isMobileCheck()) {
          backBtnTransition($targetEl);
          toggleScrolling(true);
        }
        return;
      }

      if (!$root.classList.contains('transition-start') && isMobileCheck()) {
        toggleScrolling();
        $root.classList.add('transition-start');
      }

      $subnavPanelLinks.forEach(item => item.classList.remove('active'));
      $targetPanel.classList.remove('invisible');
      setTimeout(()=>{
        $targetEl.classList.add('active');
        $allPanels.forEach(item => item.classList.add('invisible'));
        $targetPanel.classList.remove('invisible');
      }, 500);
    },
    subsitePageCheck: () => {
      return !!document.getElementById('subsite-header');
    },
    isMobileCheck: () => {
      return window.innerWidth < 1025;
    },
    isAndroidCheck: () => {
      return /(android)/i.test(navigator.userAgent);
    },
    updateCyoaPosition: () => {
      const {isMobileCheck} = Drupal.behaviors.componentCyoa;

      if (!isMobileCheck()) {
        const {getElementHeight} = Drupal.behaviors.componentCyoa;

        const $cyoa = document.querySelector('main .cyoa');
        const $headerNav = document.querySelector('body header.region-header .main-navigation-wrapper');
        const $alert = document.getElementById('sitewide-alert');
        const $adminUI = document.getElementById('toolbar-bar');
        const $adminUInav = document.getElementById('toolbar-item-administration-tray');
        const adminUIHeight = getElementHeight($adminUI);
        const adminNavHeight = getElementHeight($adminUInav);
        const $headerHeight = getElementHeight($headerNav);
        const viewportHeight = window.innerHeight;
        const cyoaHeight = 464;

        let $alertHeight = $alert ? getElementHeight($alert) : 0;
        let adminHeaderHeight = $alertHeight + $headerHeight + adminUIHeight + adminNavHeight;
        let availableSpace = viewportHeight - adminHeaderHeight - cyoaHeight;
        let offset = availableSpace > 0 ? availableSpace / 2 + adminHeaderHeight : 48 + adminHeaderHeight;

        $cyoa.style.top = `${offset}px`;
      }
    },
    positionCyoa: () => {
      const {updateCyoaPosition} = Drupal.behaviors.componentCyoa;

      const $cyoa = document.querySelector('main .cyoa');
      const $alert = document.getElementById('sitewide-alert');
      const $closeAlertButton = document.querySelector('.sitewide-alert__dismiss');

      updateCyoaPosition();

      if ($cyoa) {
        const cyoaResizeObserver = new ResizeObserver(() => {
          updateCyoaPosition();
        });

        cyoaResizeObserver.observe($cyoa);
      }

      if ($alert && $closeAlertButton) {
        $closeAlertButton.addEventListener('click', updateCyoaPosition);
      }
    },
    revealCyoa: () => {
      const $allCyoaItems = document.querySelectorAll('.cyoa');
      $allCyoaItems.forEach($cyoaItem => {
        $cyoaItem.querySelector('.cyoa-nav-primary').classList.remove('hidden');
      });
    },
    addAndroidFieldEvents: ($root) => {
      const {isAndroidCheck} = Drupal.behaviors.componentCyoa;
      if (!isAndroidCheck()) {
        return;
      }
      const $allFields = $root.querySelectorAll('input, select, textarea');
      $allFields.forEach(($field) => {
        $field.addEventListener('blur', () => {
          document.body.scrollTop = 0;
          const $subnavPanel = $field.closest('[data-height]');
          $subnavPanel.style.height = $subnavPanel.dataset.height;
        });
      });
    },
    initCyoa: ($targetRoot) => {
      const componentContext = Drupal.behaviors.componentCyoa;
      const {navClickHandler, subNavPanelClickHandler, isMobileCheck, positionCyoa, resetCyoa, addAndroidFieldEvents} = componentContext;

      const $primaryNav = $targetRoot.querySelector('.cyoa-nav-primary');
      const $allNavItems = $primaryNav.querySelectorAll('li');
      const $allCloseButtons = $primaryNav.closest('.cyoa').querySelectorAll('.cyoa-close-btn');
      $targetRoot.closest('section').classList.add('cyoa-block');
      if (isMobileCheck()) {
        $targetRoot.classList.add('mobile');
        addAndroidFieldEvents($targetRoot);
      }
      positionCyoa($primaryNav);

      setTimeout(componentContext.revealCyoa, 500);

      $allCloseButtons.forEach(($closeButton) => {
        $closeButton.addEventListener('click', resetCyoa);
      });

      $allNavItems.forEach($navItem => {
        $navItem.dataset.childnav = ($navItem.querySelector(':scope > ul') !== null).toString();
        $navItem.dataset.subnavpanel = ($navItem.querySelector(':scope > .cyoa-subnav-panel') !== null).toString();
      });

      const $parentNavItems = $primaryNav.querySelectorAll('[data-childnav="true"] > .cyoa-nav-item--trigger');
      const $subnavPanelLinks = $primaryNav.querySelectorAll('[data-subnavpanel="true"]');


      $parentNavItems.forEach($navItem => {
        $navItem.addEventListener('click', navClickHandler);
      });

      $subnavPanelLinks.forEach(($subnavPanelItem, index, array) => {
        $subnavPanelItem.addEventListener('click', subNavPanelClickHandler.bind(event, array));
      });
    },
    attach: (context) => {
      const componentContext = Drupal.behaviors.componentCyoa;
      // eslint-disable-next-line
      $(once('initCyoa', '.cyoa', context)).each(function () {
        componentContext.initCyoa(this);
      });
    }
  };
})(jQuery, Drupal, once);

